<div>
  <form [formGroup]="formConsulta">
    <div class="form-row">
       <mat-form-field class="mat-form-field" subscriptSizing="dynamic">
        <mat-label>{{labelDaDescricao}}</mat-label>
        <input matInput formControlName="descricao" type="text" (keyup)="onSearch($event.target.value)" onFocus="this.select()"
          [(ngModel)]="descricaoItem" required="{{campoRequerido}}" [matAutocomplete]="auto"/>
        <button mat-icon-button matSuffix (click)="openAutocomplete()" type="button" [disabled]="disabled">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
          <mat-autocomplete #auto="matAutocomplete">
            @for (result of this.consultaCustomizada.resultados; track $index; let i = $index) {
            <mat-option class="mat-options"
            (click)="selecionarItem(result)">
              {{ result.descricao }}
            </mat-option>
            }
          </mat-autocomplete>
      </mat-form-field>
    </div>
  </form>
</div>
